import get from './get';
import update from './update';
import exportXlsx from './exportXlsx';

export default [get, update, exportXlsx];
